import React, { useState, useEffect } from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import Banner from "../../utilities/Banner/Banner";
import SearchInput from "../../utilities/SearchInput/SearchInput";
import { HomePageWrapper, ActionBoxWrapper } from "./HomePageStyled";
import StatusBox from "../../utilities/StatusBox/StatusBox";
import FormControl from "@mui/material/FormControl";
import CustomButton from "../../utilities/Button/Button";
import IconButton from "@mui/material/IconButton";
import ActionTabTable from "../../utilities/Table/Table";
import ControlPointDuplicateOutlinedIcon from "@mui/icons-material/ControlPointDuplicateOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import { Content } from "./Content";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllQuotesByOppurtunity,
  getOpportunityByUser,
  saveOpportunityDetails,
} from "../../../Actions/QuoteAction";
import { getCRMDataDetails } from "../../../Actions/CRMAction";
import { getLoggedUserDetails } from "../../../Actions/UserAction";
import { isEmpty } from "lodash";
import image1 from "../../../images/allstatusinputIcon.svg";
import checkicon from "../../../images/checkIcon.svg";
import teamicon from "../../../images/teamIcon.svg";
import timeicon from "../../../images/timeIcon.svg";
import approveicon from "../../../images/approveIcon.svg";
import fileicon from "../../../images/fileIcon.svg";
import closeicon from "../../../images/closeIcon.svg";
import pendingicon from "../../../images/pendingIcon.svg";
import { getDecryptedText } from "../../../Actions/CommonAction";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {
  LocalStorageKeys,
  PageName,
  QuoteStatus,
  UserRole,
  OpportunityType,
} from "../../QuoteRequest/Content";
import Notification from "../../utilities/Notification/Notification";
import { Severity } from "../../utilities/Notification/NotificationContent";
import Loader from "../../utilities/Loader/Loader";
import { pagenotPageNotFound } from "../../utilities/PageNotFound/PageNotFound";
import { Congiguration } from "../../../Constants/AppConstants";
import { isJsonString } from "../../../Helper/Helper";
import {
  GET_CRM_DATA,
  GET_LOGGED_USER_DETAILS,
} from "../../../ActionTypes/ActionTypes";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import moment from "moment";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import {
  SetCRMDataInSession,
  SetLoggedInUserDataInSession,
  getCurrentOpportunityDataFromSession,
} from "../../../Helper/SessionHelper";

const HomePage = () => {
  const dispatch = useDispatch();
  let search = window.location.search;

  let params = new URLSearchParams(search);
  //First preference is to the selected opportunity if changed from the dropdown
  let oppurtunityid =
    sessionStorage.getItem(LocalStorageKeys.CURRENTWORKINGOPPORTUNITY) ??
    sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID);
  let useremail = sessionStorage.getItem(LocalStorageKeys.USEREMAIL);

  const loggedUserLocalStorage = isJsonString(
    sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER),
  )
    ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
    : null;
  const crmDataLocalStorage = getCurrentOpportunityDataFromSession();

  let loggedUser = useSelector((state) => state?.UserReducer?.loggedUser);
  let crmData = useSelector((state) => state?.CRMReducer?.crmData);
  let _opportunityList = useSelector(
    (state) => state?.QuoteReducer?.opp0rtunities,
  );

  if (
    loggedUser !== undefined &&
    Object.keys(loggedUser).length === 0 &&
    loggedUser.constructor === Object &&
    loggedUserLocalStorage !== null
  ) {
    loggedUser = loggedUserLocalStorage;
    if (useremail?.toUpperCase() !== loggedUser?.user?.email?.toUpperCase()) {
      loggedUser = [];
    }
    //storing user login to reducer
    dispatch({
      type: GET_LOGGED_USER_DETAILS,
      payload: loggedUser,
    });
  }

  if (
    crmData !== undefined &&
    Object.keys(crmData).length === 0 &&
    crmData.constructor === Object &&
    crmDataLocalStorage !== null
  ) {
    crmData = crmDataLocalStorage;
    //storing CRM data to reducer
    dispatch({
      type: GET_CRM_DATA,
      payload: crmData,
    });
  }

  const statusInfo = [
    {
      imageSrc: image1,
      text: Content.ALL,
      value: 0,
      id: 0,
    },
    {
      imageSrc: checkicon,
      text: Content.SUBMITTED,
      value: 0,
      id: QuoteStatus.SUBMITTED,
    },
    {
      imageSrc: teamicon,
      text: Content.PENDING_PRICING,
      value: 0,
      id: QuoteStatus.QUOTEPENDINGPRICINGTEAM,
    },
    {
      imageSrc: timeicon,
      text: Content.PENDING_APPROVAL,
      value: 0,
      id: QuoteStatus.QUOTEPENDINGSAMLEADERSHIP,
    },
    {
      imageSrc: approveicon,
      text: Content.APPROVED,
      value: 0,
      id: QuoteStatus.QUOTEAPPROVED,
    },
    {
      imageSrc: fileicon,
      text: Content.CONTRACTED,
      value: 0,
      id: QuoteStatus.CONTRACTED,
    },
    {
      imageSrc: closeicon,
      text: Content.CLOSE_CONTRACTED,
      value: 0,
      id: QuoteStatus.QUOTECLOSED,
    },
    {
      imageSrc: pendingicon,
      text: Content.PENDING_REQUESTOR,
      value: 0,
      id: QuoteStatus.QUOTEPENDINGINITIALREQUESTOR,
    },
    {
      imageSrc: checkicon,
      text: Content.PENDING_PRICINGMANAGER,
      value: 0,
      id: QuoteStatus.QUOTEPENDINGPRICINGMANAGER,
    },
    {
      imageSrc: teamicon,
      text: Content.PENDING_PRICINGMANAGERANDSAMLEADERSHIP,
      value: 0,
      id: QuoteStatus.QUOTEPENDINGPRICINGMANAGERANDSAMLEADERSHIP,
    },
    {
      imageSrc: timeicon,
      text: Content.PENDING_PRICINGVPANDSAMLEADERSHIP,
      value: 0,
      id: QuoteStatus.QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP,
    },
    {
      imageSrc: timeicon,
      text: Content.PENDING_PRICINGVP,
      value: 0,
      id: QuoteStatus.QUOTEPENDINGPRICINGVP,
    },
  ];

  const [loggedinuser, setLoggedinUser] = useState({});
  const [opportunityList, setOpportunityList] = useState([]);
  const [selectedOpportunity, setSelectedOpportunity] = useState("");
  const [quoteList, setQuoteList] = useState([]);
  const [allQuotes, setAllQuotes] = useState([]);
  const [opportunity, setOpportunity] = useState({});
  const [searchText, setsearchText] = useState("");
  const [pageNumber, setPageNumber] = useState(Content.INITALPAGENO);
  const [searchSelectedOpportunity, setsearchSelectedOpportunity] = useState({
    oppurtunityId: "0",
    oppurtunity: "All",
    oppurtunityName: "All",
  });
  const [loading, setLoading] = useState(false);
  const [quoteListLoading, setQuoteListLoading] = useState(false);
  const [createBtnLoading, setCreateBtnLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading please wait");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationSeverity, setNotificationSeverity] = useState("");
  const [isAdditionalMember, setIsAdditionalMember] = useState(false);
  const [previousQuotes, setPreviousQuotes] = useState([]);
  const [filteredStatus, setStatusInfo] = useState(statusInfo);
  const [loadingState, setLoadingState] = useState(true);
  const [opportunityLoading, setOpportunityLoading] = useState(false);
  const [isMyRequests, setIsMyRequests] = useState(false);

  //To handle change in "isMyRequests" variable
  useEffect(() => {
    if (isMyRequests) {
      const currentQuoteList = [...quoteList];
      setPreviousQuotes([...currentQuoteList]);
      setQuoteList([]);
      setPageNumber(Content.INITALPAGENO);
      setQuoteList([
        ...currentQuoteList.filter(
          (x) => x.createdBy === loggedinuser?.user?.id,
        ),
      ]);
    } else {
      setQuoteList([]);
      setPageNumber(Content.INITALPAGENO);
      setQuoteList([...previousQuotes]);
    }
  }, [isMyRequests]);

  //Handles change in any state, loads all data
  useEffect(() => {
    window.scrollTo(0, 0);
    sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, PageName.HOMEPAGE);
    document.title = "Home";

    if (oppurtunityid) {
      GetDataAndBindComponents(oppurtunityid);
    } else if (!oppurtunityid && search) {
      const encrParam = search.replace("?", "");
      getDecryptedParamValues(encrParam);
    } else if (crmData.opportunityId && loggedUser?.user) {
      setOpportunity({ ...crmData });
      setSelectedOpportunity(crmData.opportunityId);
      getOppurtintyList(crmData, loggedUser?.user.id);
      getQuoteList(crmData.opportunityId, loggedUser?.user.id);
      isTeamAdditionalMember(loggedUser?.user?.email, crmData);
      //setting email and opp id in sessionStorage to handle page refresh
      if (
        ((!sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) || //undefined OR NULL
          (sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) == null &&
            sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) ==
              "null")) &&
          crmData.opportunityId) ||
        sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) !==
          crmData.opportunityId
      ) {
        sessionStorage.setItem(
          LocalStorageKeys.OPPORTUNITYID,
          crmData.opportunityId,
        );
      }

      if (
        ((!sessionStorage.getItem(LocalStorageKeys.USEREMAIL) ||
          (sessionStorage.getItem(LocalStorageKeys.USEREMAIL) == null &&
            sessionStorage.getItem(LocalStorageKeys.USEREMAIL) == "null")) &&
          loggedUser?.user?.email) ||
        sessionStorage.getItem(LocalStorageKeys.USEREMAIL) !=
          loggedUser?.user?.email
      ) {
        sessionStorage.setItem(
          LocalStorageKeys.USEREMAIL,
          loggedUser?.user?.email,
        );
      }
    } else if (
      sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) &&
      sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) != null &&
      sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) != "null" &&
      sessionStorage.getItem(LocalStorageKeys.USEREMAIL) &&
      sessionStorage.getItem(LocalStorageKeys.USEREMAIL) != null &&
      sessionStorage.getItem(LocalStorageKeys.USEREMAIL) != "null"
    ) {
      oppurtunityid = sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID);
      useremail = sessionStorage.getItem(LocalStorageKeys.USEREMAIL);
      GetDataAndBindComponents(oppurtunityid);
    } else if (!oppurtunityid && useremail) {
      setNotificationMessage(
        "Opportunity data not found! Please launch CPQ from Dynamics 365.",
      );
      setNotificationSeverity(Severity.WARNING);
      setShowNotification(true);
    }
  }, []);

  function getDecryptedParamValues(encryptedParam) {
    setLoadingState(true);
    dispatch(getDecryptedText(encryptedParam))
      .then((decrParam) => {
        console.log("decrParam", decrParam);
        params = new URLSearchParams("?" + decrParam);
        oppurtunityid = params.get("OpportunityId");

        //setting email and opp id in localStorage to handle page refresh
        if (
          !sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) ||
          (sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) == null &&
            sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) == "null") ||
          sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID) !=
            oppurtunityid
        ) {
          sessionStorage.setItem(LocalStorageKeys.OPPORTUNITYID, oppurtunityid);
        }

        GetDataAndBindComponents(oppurtunityid);
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
  }

  function GetDataAndBindComponents(oppurtunityid) {
    let opId = oppurtunityid;
    if (oppurtunityid === "0") {
      setSelectedOpportunity(oppurtunityid);
      sessionStorage.setItem(
        LocalStorageKeys.CURRENTWORKINGOPPORTUNITY,
        oppurtunityid,
      );
      getQuoteList(oppurtunityid, loggedUser?.user.id);
      oppurtunityid = sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID);

      const opportunityObj = getCurrentOpportunityDataFromSession();
      if (
        _opportunityList &&
        _opportunityList !== null &&
        _opportunityList.length > 0 &&
        opportunityObj &&
        opportunityObj !== null
      ) {
        PopulateOpportunityDropdown(opportunityObj, _opportunityList);
      } else {
        getOppurtintyList(opportunityObj, loggedUser?.user.id);
      }
    }

    setLoadingState(true);
    setLoadingText("Please wait : fetching CRM data..");
    const crmSessionJson =
      sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL) &&
      isJsonString(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL))
        ? sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL)
        : null;

    const crmDataInitial =
      crmSessionJson !== null ? JSON.parse(crmSessionJson) : null;

    if (
      crmDataInitial &&
      crmDataInitial !== null &&
      isJsonString(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL)) &&
      JSON.parse(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL))
        ?.opportunityId === oppurtunityid
    ) {
      setOpportunity({ ...crmDataInitial });
      setSelectedOpportunity(crmDataInitial.opportunityId);
      getAndSetLoggedUser(crmDataInitial);
    } else {
      if (
        oppurtunityid &&
        oppurtunityid !== null &&
        oppurtunityid !== "0" &&
        oppurtunityid !== 0
      ) {
        setLoadingState(true);
        setLoadingText("Please wait : fetching CRM data..");
        dispatch(getCRMDataDetails(oppurtunityid))
          .then((data) => {
            setOpportunity({ ...data });
            SetCRMDataInSession(data, oppurtunityid);
            console.log("ll", data);
            setLoadingText("Please wait : Getting login details..");
            setSelectedOpportunity(data.opportunityId);
            getAndSetLoggedUser(data);
            //setLoadingState(false);
            //setLoading(false);
          })
          .catch((e) => {
            console.log(e);
            setLoadingState(false);
            setLoading(false);
          });
      }
    }
  }

  function getAndSetLoggedUser(crmData) {
    useremail = useremail ?? sessionStorage.getItem(LocalStorageKeys.USEREMAIL);
    if (useremail && useremail !== "") {
      sessionStorage.setItem(LocalStorageKeys.USEREMAIL, useremail);
      setLoadingState(true);
      setLoadingText("Please wait : Getting user details..");
      dispatch(getLoggedUserDetails(useremail))
        .then((userData) => {
          console.log("dd", crmData);

          if (
            !userData ||
            userData.user === null ||
            userData.user === "null" ||
            !userData.user.isActive
          ) {
            sessionStorage.clear();
            localStorage.clear();

            navigate("/pageNotfound", {
              state: {
                status: Congiguration.unauthorizedStatus,
              },
            });
            return false;
          }
          setLoggedinUser({ ...userData }); //locally useState
          SetLoggedInUserDataInSession(userData); //session
          getQuoteList(oppurtunityid, userData?.user.id);
          getOppurtintyList(crmData, userData?.user.id);
          isTeamAdditionalMember(userData?.user?.email, crmData);
          const myDate =
            moment(crmData.programStartDate).format("YYYY-MM-DDT00:00:00.000") +
            "Z";
          saveOpportunityAndHeadCountFromCRM(
            myDate,
            crmData,
            userData?.user.id,
          );
          //setLoadingState(false);
          //setLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
          setLoading(false);
        });
    }
  }

  const getOppurtintyList = async (opportunityDtls, userId) => {
    setLoading(true);
    setLoadingState(true);
    setLoadingText("Please wait : Getting all opportunities for user..");
    await dispatch(getOpportunityByUser(userId))
      .then((data) => {
        PopulateOpportunityDropdown(opportunityDtls, data);
        setLoading(false);
        setLoadingState(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
        setLoadingState(false);
      });
  };

  const PopulateOpportunityDropdown = (opportunityObj, opportunityListObj) => {
    let oppList = opportunityListObj.map(
      ({ oppurtunityId, oppurtunity, oppurtunityName }) => ({
        oppurtunityId,
        oppurtunity,
        oppurtunityName,
      }),
    );

    var index = oppList.findIndex(
      (x) => x.oppurtunityId === opportunityObj.opportunityId,
    );

    if (index === -1) {
      oppList.push({
        oppurtunityId: opportunityObj.opportunityId,
        oppurtunity: opportunityObj.opportunity,
        oppurtunityName: opportunity.opportunityName,
      });
    }
    const allObj = {
      oppurtunityId: "0",
      oppurtunity: "All",
      oppurtunityName: "All",
    };
    //oppList.push(allObj);

    setsearchSelectedOpportunity(
      oppList.find(
        (option) => option.oppurtunityId === opportunityObj.opportunityId,
      ),
    );
    setOpportunityList([allObj, ...oppList]);

    if (!selectedOpportunity || selectedOpportunity === "") {
      setSelectedOpportunity(
        sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID),
      );
    }

    let opId = sessionStorage.getItem(
      LocalStorageKeys.CURRENTWORKINGOPPORTUNITY,
    )
      ? sessionStorage.getItem(LocalStorageKeys.CURRENTWORKINGOPPORTUNITY)
      : sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID);
    if (opId === "0") {
      setsearchSelectedOpportunity(allObj);
      setSelectedOpportunity(allObj?.oppurtunityId);
    }
  };

  const customSort = (array, firstStatus, secondStatus) => {
    return array.sort((a, b) => {
      if (a.quoteStatusId === firstStatus && b.quoteStatusId !== firstStatus) {
        return -1; // a comes before b
      } else if (
        a.quoteStatusId !== firstStatus &&
        b.quoteStatusId === firstStatus
      ) {
        return 1; // b comes before a
      } else if (
        a.quoteStatusId === secondStatus &&
        b.quoteStatusId !== secondStatus
      ) {
        return -1; // a comes before b
      } else if (
        a.quoteStatusId !== secondStatus &&
        b.quoteStatusId === secondStatus
      ) {
        return 1; // b comes before a
      } else {
        return 0; // no change in order
      }
    });
  };
  //For initial dashboard binding
  function InitQuotes(quotes) {
    if (isMyRequests) {
      setQuoteList([
        ...quotes.filter((x) => x.createdBy === loggedinuser?.user?.id),
      ]);
    } else {
      setQuoteList([...quotes]);
    }
  }

  const getPendingRoleIds = (quote) => {
    const pendingApproverRoles = quote?.pendingApproverRoles;

    if (!pendingApproverRoles) {
      return [];
    }

    if (Array.isArray(pendingApproverRoles)) {
      return pendingApproverRoles
        .map((roleId) => Number(roleId))
        .filter((roleId) => Number.isFinite(roleId));
    }

    if (typeof pendingApproverRoles === "string") {
      return pendingApproverRoles
        .split(",")
        .map((roleId) => Number(roleId.trim()))
        .filter((roleId) => Number.isFinite(roleId));
    }

    if (typeof pendingApproverRoles === "number") {
      return Number.isFinite(pendingApproverRoles)
        ? [pendingApproverRoles]
        : [];
    }

    return [];
  };

  const isQuoteInSelectedStatus = (quote, quoteStatus) => {
    const pendingRoles = getPendingRoleIds(quote);

    const hasRole = (roleId) => pendingRoles.includes(roleId);
    const hasOnlyRole = (roleId) => hasRole(roleId) && pendingRoles.length === 1;

    switch (quoteStatus) {
      case QuoteStatus.QUOTEPENDINGSAMLEADERSHIP:
        return (
          quote.quoteStatusId === QuoteStatus.QUOTEPENDINGSAMLEADERSHIP ||
          (quote.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGMANAGERANDSAMLEADERSHIP &&
            hasOnlyRole(UserRole.SAMLEADERSHIPTEAM)) ||
          (quote.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP &&
            hasOnlyRole(UserRole.SAMLEADERSHIPTEAM))
        );

      case QuoteStatus.QUOTEPENDINGPRICINGMANAGER:
        return (
          quote.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGMANAGER ||
          (quote.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGMANAGERANDSAMLEADERSHIP &&
            hasOnlyRole(UserRole.PRICINGMANAGER))
        );

      case QuoteStatus.QUOTEPENDINGPRICINGVP:
        return (
          quote.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGVP ||
          (quote.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP &&
            hasOnlyRole(UserRole.PRICINGVP))
        );

      case QuoteStatus.QUOTEPENDINGPRICINGMANAGERANDSAMLEADERSHIP:
        if (
          quote.quoteStatusId ===
            QuoteStatus.QUOTEPENDINGPRICINGMANAGERANDSAMLEADERSHIP &&
          pendingRoles.length === 0
        ) {
          return true;
        }

        return (
          quote.quoteStatusId ===
            QuoteStatus.QUOTEPENDINGPRICINGMANAGERANDSAMLEADERSHIP &&
          hasRole(UserRole.PRICINGMANAGER) &&
          hasRole(UserRole.SAMLEADERSHIPTEAM)
        );

      case QuoteStatus.QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP:
        if (
          quote.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP &&
          pendingRoles.length === 0
        ) {
          return true;
        }

        return (
          quote.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP &&
          hasRole(UserRole.PRICINGVP) &&
          hasRole(UserRole.SAMLEADERSHIPTEAM)
        );

      default:
        return quote.quoteStatusId === quoteStatus;
    }
  };

  function filterQuotesByStatus(quoteStatus, data) {
    console.log("Is My Request", isMyRequests);
    if (isMyRequests) {
      setPreviousQuotes([
        ...data.filter((x) => isQuoteInSelectedStatus(x, quoteStatus)),
      ]);
      setQuoteList([
        ...data.filter(
          (x) =>
            isQuoteInSelectedStatus(x, quoteStatus) &&
            x.createdBy === loggedinuser?.user?.id,
        ),
      ]);
    } else {
      setQuoteList([
        ...data.filter((x) => isQuoteInSelectedStatus(x, quoteStatus)),
      ]);
    }
  }

  function getStatusDataLengthValueByStatus(quoteStatus, data) {
    if (isMyRequests) {
      return data.filter(
        (x) =>
          isQuoteInSelectedStatus(x, quoteStatus) &&
          x.createdBy === loggedinuser?.user?.id,
      ).length;
    } else {
      return data.filter((x) => isQuoteInSelectedStatus(x, quoteStatus)).length;
    }
  }

  function sortQuotesBasedOnUser(quotesData) {
    if (loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM || 
      loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER || 
      loggedUser?.userRole[0]?.id === UserRole.PRICINGVP) {
      let quotes = customSort(
        quotesData,
        QuoteStatus.QUOTEPENDINGPRICINGTEAM,
        QuoteStatus.QUOTEPENDINGSAMLEADERSHIP,
      );
      InitQuotes([...quotes]);
      setAllQuotes([...quotes]);
    } else if (loggedUser?.userRole[0]?.id === UserRole.SAMLEADERSHIPTEAM) {
      let quotes = customSort(
        quotesData,
        QuoteStatus.QUOTEPENDINGSAMLEADERSHIP,
        QuoteStatus.QUOTEPENDINGPRICINGTEAM,
      );
      InitQuotes([...quotes]);
      setAllQuotes([...quotes]);
    }
  }

  function getQuoteList(opportunityid, userid) {
    setLoading(true);
    setQuoteListLoading(true);
    setLoadingText("Please wait : Getting all quotes..");
    setLoadingState(true);
    dispatch(getAllQuotesByOppurtunity(opportunityid, userid))
      .then((data) => {
        //Assigned Row Id and pending with
        let id = 1;
        data.forEach((x) => {
          x.rowId = id++;
          x.pendingWithWhom =
            x.quoteStatusId == 2
              ? "Pricing Team"
              : (x.pendingWithWhom = x.quoteStatusId == 3 ? "SAM" : "None");
        });

        //Duplicate removed
        data = data?.filter(
          (obj, index, arr) =>
            !arr
              ?.slice(0, index)
              ?.some((prevObj) => prevObj?.quoteId === obj?.quoteId),
        );

        //Sort by created date
        data = data.sort(
          (a, b) => new Date(b.createdDate) - new Date(a.createdDate),
        );

        InitQuotes([...data]);
        setAllQuotes([...data]);

        //For all opportunities[dropdown value all]
        if (opportunityid == 0) {
          sortQuotesBasedOnUser(data);
        }

        SetStatusFilterValues(data);
        setLoadingState(false);
        setQuoteListLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
        setLoadingState(false);
        setQuoteListLoading(false);
      });
  }
  const handleChangePage = (event, newPage) => {
    setPageNumber(newPage);
  };

  const SetStatusFilterValues = (data) => {
    let statusfilter = [
      {
        imageSrc: image1,
        text: Content.ALL,
        value: data.length,
        id: 0,
      },
      {
        imageSrc: checkicon,
        text: Content.SUBMITTED,
        value: getStatusDataLengthValueByStatus(QuoteStatus.SAVEASDRAFT, data),
        id: QuoteStatus.SAVEASDRAFT,
      },
      {
        imageSrc: teamicon,
        text: Content.PENDING_PRICING,
        value: getStatusDataLengthValueByStatus(
          QuoteStatus.QUOTEPENDINGPRICINGTEAM,
          data,
        ),
        id: QuoteStatus.QUOTEPENDINGPRICINGTEAM,
      },
      {
        imageSrc: timeicon,
        text: Content.PENDING_APPROVAL,
        value: getStatusDataLengthValueByStatus(
          QuoteStatus.QUOTEPENDINGSAMLEADERSHIP,
          data,
        ),
        id: QuoteStatus.QUOTEPENDINGSAMLEADERSHIP,
      },
      {
        imageSrc: approveicon,
        text: Content.APPROVED,
        value: getStatusDataLengthValueByStatus(
          QuoteStatus.QUOTEAPPROVED,
          data,
        ),
        id: QuoteStatus.QUOTEAPPROVED,
      },
      {
        imageSrc: fileicon,
        text: Content.CONTRACTED,
        value: getStatusDataLengthValueByStatus(
          QuoteStatus.CONTRACTED,
          data,
        ),
        id: QuoteStatus.CONTRACTED,
      },
      {
        imageSrc: closeicon,
        text: Content.CLOSE_CONTRACTED,
        value: getStatusDataLengthValueByStatus(QuoteStatus.QUOTECLOSED, data),
        id: QuoteStatus.QUOTECLOSED,
      },
      {
        imageSrc: pendingicon,
        text: Content.PENDING_REQUESTOR,
        value: getStatusDataLengthValueByStatus(
          QuoteStatus.QUOTEPENDINGINITIALREQUESTOR,
          data,
        ),
        id: QuoteStatus.QUOTEPENDINGINITIALREQUESTOR,
      },
      {
        imageSrc: checkicon,
        text: Content.PENDING_PRICINGMANAGER,
        value: getStatusDataLengthValueByStatus(
          QuoteStatus.QUOTEPENDINGPRICINGMANAGER,
          data,
        ),
        id: QuoteStatus.QUOTEPENDINGPRICINGMANAGER,
      },
      {
        imageSrc: teamicon,
        text: Content.PENDING_PRICINGMANAGERANDSAMLEADERSHIP,
        value: getStatusDataLengthValueByStatus(
          QuoteStatus.QUOTEPENDINGPRICINGMANAGERANDSAMLEADERSHIP,
          data,
        ),
        id: QuoteStatus.QUOTEPENDINGPRICINGMANAGERANDSAMLEADERSHIP,
      },
      {
        imageSrc: timeicon,
        text: Content.PENDING_PRICINGVPANDSAMLEADERSHIP,
        value: getStatusDataLengthValueByStatus(
          QuoteStatus.QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP,
          data,
        ),
        id: QuoteStatus.QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP,
      },
      {
        imageSrc: timeicon,
        text: Content.PENDING_PRICINGVP,
        value: getStatusDataLengthValueByStatus(
          QuoteStatus.QUOTEPENDINGPRICINGVP,
          data,
        ),
        id: QuoteStatus.QUOTEPENDINGPRICINGVP,
      },
    ];

    setStatusInfo(statusfilter);
  };

  const handleOpportunityChange = (event, value) => {
    if (value) {
      setOpportunityLoading(true);
      sessionStorage.removeItem(LocalStorageKeys.BUNDLEQUOTEIDS);
      setsearchSelectedOpportunity(value);
      setSelectedOpportunity(value?.oppurtunityId);
      sessionStorage.setItem(
        LocalStorageKeys.CURRENTWORKINGOPPORTUNITY,
        value?.oppurtunityId,
      );
      sessionStorage.setItem(
        LocalStorageKeys.OPPORTUNITYID,
        value?.oppurtunityId,
      );
      setLoadingState(true);
      setPageNumber(Content.INITALPAGENO);
      if (value?.oppurtunityId !== "0") {
        getQuoteList(value?.oppurtunityId, loggedUser?.user.id);
        setLoadingState(true);
        setLoadingText("Please wait : Updating CRM data..");
        dispatch(getCRMDataDetails(value?.oppurtunityId))
          .then((data) => {
            sessionStorage.removeItem(LocalStorageKeys.CRMDATAINITIAL);
            const jsonCRMData = JSON.stringify(data);
            sessionStorage.setItem(
              LocalStorageKeys.CRMDATAINITIAL,
              jsonCRMData,
            );
            setOpportunity({ ...data });
            const myDate =
              moment(crmData.programStartDate).format(
                "YYYY-MM-DDT00:00:00.000",
              ) + "Z";
            setLoadingState(false);
            saveOpportunityAndHeadCountFromCRM(
              myDate,
              data,
              loggedUser?.user.id,
            );
            isTeamAdditionalMember(loggedUser?.user?.email, data);
            setOpportunityLoading(false);
          })
          .catch((e) => {
            console.log(e);
            setLoading(false);
            setLoadingState(false);
            setOpportunityLoading(false);
          });
      } else {
        getQuoteList(value?.oppurtunityId, loggedUser?.user.id);
      }
    } else {
      return false;
    }
  };

  function saveOpportunityAndHeadCountFromCRM(formattedDate, crmData, userId) {
    //setLoadingState(true);
    const opportunity = {
      oppurtunityId: crmData.opportunityId,
      oppurtunity: crmData.opportunity,
      oppurtunityName: crmData.opportunityName,
      oppurtunityType: OpportunityType.find(
        (x) => x.crmOpportunityType === crmData.opportunityType,
      )?.cpqOpportunityType,
      oppurtunityReferrerName: crmData.opportunityReferrerName,
      accountName: crmData.account,
      billingCountry: crmData.billingCountry,
      programStartDate: formattedDate,
      commissionPercent: crmData.commissionPercentage
        ? crmData.commissionPercentage.toString()
        : "",
      isBroker: crmData.isBroker === "Yes",
      memberOf: crmData.wpo_memberoftext,
      currencyCode: crmData.currencyCode,
      accountSubType: crmData.accountSubType,
      accountOwner: crmData.accountOwner,
      accountOwnerEmail: crmData.accountOwnerMail,
      opportunitySaleLead: crmData.opportunitySaleLead,
      saleLeadEmail: crmData?.opportunitySaleLeadEmail,
      opportunityAmLead: crmData.opportunityAmLead,
      amLeadEmail: crmData?.opportunityAmLeadEmail,
      opportunityIsAdditionalTeamMember:
        crmData.opportunityIsAdditionalTeamMember === "Yes",
      opportunityAdditionTeamMember: crmData.opportunityAdditionTeamMember,
      additionTeamMemberEmail: crmData?.opportunityAdditionTeamMemberEmail,
      companyId: Congiguration.CompanyId,
      ucmsId: crmData?.ucmsId,
      userId: userId,
    };

    dispatch(saveOpportunityDetails(opportunity))
      .then((data) => {
        setLoadingState(false);
        console.log("Save_Opportunity_Data", data);
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
  }
  function isTeamAdditionalMember(email, crmData) {
    let crmAdditionalEmail =
      crmData?.opportunityAdditionTeamMemberEmail === undefined
        ? crmData?.additionTeamMemberEmail
        : crmData?.opportunityAdditionTeamMemberEmail;
    let crmSaleLdEmail =
      crmData?.opportunitySaleLeadEmail === undefined
        ? crmData?.saleLeadEmail
        : crmData?.opportunitySaleLeadEmail;
    let crmAMLdEmail =
      crmData?.opportunityAmLeadEmail === undefined
        ? crmData?.amLeadEmail
        : crmData?.opportunityAmLeadEmail;
    let result =
      email?.trim() === crmAdditionalEmail?.trim() ||
      email?.trim() === crmSaleLdEmail?.trim() ||
      email?.trim() === crmAMLdEmail?.trim();

    setIsAdditionalMember(result);

    return result;
  }

  const handleQuoteView = (event, quoteId, oppurtunityId, actionType) => {
    // setLoading(true);
    setLoadingState(true);
    setLoadingText("Please wait : Fetching CRM data..");

    if (actionType === "Edit") {
      console.log("qt edit", quoteId);
      console.log("evt", actionType);
      EditRequest(quoteId);
    } else {
      dispatch(getCRMDataDetails(oppurtunityId))
        .then((data) => {
          sessionStorage.removeItem(LocalStorageKeys.CRMDATAINITIAL);
          const jsonCRMData = JSON.stringify(data);
          sessionStorage.setItem(LocalStorageKeys.CRMDATAINITIAL, jsonCRMData);

          switch (actionType) {
            case "View":
              console.log("qt view", quoteId);
              console.log("evt", actionType);
              navigate("/viewquote", {
                state: {
                  quoteId: quoteId,
                },
              });
              break;

            case "Duplicate":
              console.log("qt duplicate", quoteId);
              console.log("evt", actionType);
              DuplicateRequest(quoteId);
              break;
            default:
              break;
          }
          setLoading(false);
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
          setLoadingState(false);
        });
    }
  };

  function isEdit(row) {
    const roleId = loggedUser?.userRole[0]?.id;

    const isCreator = loggedUser?.user?.id === row.createdBy;

    const isPendingApprover = row.pendingApproverRoles?.includes(roleId);

    /*
    Creator / Additional member edits
    allowed during draft + initial requestor
    */

    if (
      (isCreator || isAdditionalMember) &&
      (row.quoteStatusId === QuoteStatus.SAVEASDRAFT ||
        row.quoteStatusId === QuoteStatus.QUOTEPENDINGINITIALREQUESTOR)
    ) {
      return true;
    }

    /*
    Pending approvers can modify
    */

    if (isPendingApprover) {
      return true;
    }

    /*
    SAMTEAM special rule
    */

    if (
      roleId === UserRole.SAMTEAM &&
      row.createdByRoleId === UserRole.SAMTEAM &&
      row.quoteStatusId === QuoteStatus.QUOTEPENDINGINITIALREQUESTOR
    ) {
      return true;
    }

    return false;
  }

  const customActions = (row) => (
    <ActionBoxWrapper>
      <IconButton
        className="icon"
        aria-label="view"
        onClick={(e) =>
          handleQuoteView(e, row.quoteId, row.oppurtunityId, "View")
        }
      >
        <Tooltip id="viewbutton-report" title="View">
          <VisibilityOutlinedIcon />
        </Tooltip>
      </IconButton>
      <IconButton
        className="icon"
        aria-label="edit"
        disabled={!isEdit(row)}
        onClick={(e) =>
          handleQuoteView(e, row.quoteId, row.oppurtunityId, "Edit")
        }
      >
        <Tooltip id="viewbutton-report" title="Edit">
          <DriveFileRenameOutlineOutlinedIcon />
        </Tooltip>
      </IconButton>
      <IconButton
        className="icon"
        aria-label="duplicate"
        onClick={(e) =>
          handleQuoteView(e, row.quoteId, row.oppurtunityId, "Duplicate")
        }
      >
        <Tooltip id="viewbutton-report" title="Duplicate">
          <ControlPointDuplicateOutlinedIcon />
        </Tooltip>
      </IconButton>
    </ActionBoxWrapper>
  );
  const statusColors = {
    "Quote Pending SAM Leadership": "#8A9123",
    "Quote Pending Pricing Team": "#8A9123",
    "Quote closed": "#C81E1E",
    "Quote Approved": "#00AF97",
    "Quote Submitted": "#239155",
    Contracted: "#91238D",
    "Save as draft": "#229353",
    "Closed without approval": "#2eb71e",
    "Quote Pending \nInitial Requestor": "#E27900",

    // Add more status values and colors as needed
  };
  const customHeaderCells = [
    { id: "statusName", label: "Quote Approval Status" },
    { id: "accountName", label: "Account Name" },
    { id: "memberOf", label: "Member Of" },
    { id: "oppurtunityName", label: "Opportunity Name" },
    { id: "totalHeadCount", label: "Head Count" },
    { id: "productName", label: "Product" },
    { id: "productVariationName", label: "Product Variation" },
    { id: "sessions", label: "Session" },
    { id: "hours", label: "Hours (if applicable)" },
    {
      id: "blendedRateReqCurrency",
      label: "Blended Rate (requested Currency)",
    },
    { id: "pricingStructureName", label: "Pricing Structure" },
    { id: "totalAnnualRevenue", label: "Total Annual Revenue" },
    { id: "utilization", label: "Utilization %" },
    { id: "brokerName", label: "Broker name" },
    { id: "commission", label: "Broker commission %" },
    { id: "oppurtunity", label: "Opportunity ID" },
    { id: "approverDetails", label: "SAM Leadership Approver" },
    {
      id: "samLeadershipTeamApprovalDate",
      label: "SAM Leadership Team Approval Date",
      isDate: true,
    },
    { id: "quoteName", label: "Quote ID" },
    { id: "createdDate", label: "Created Date", isDate: true },
    { id: "pricingTeamApprover", label: "Pricing Team Approver" },
    {
      id: "pricingTeamApprovalDate",
      label: "Pricing Team  Approval Date",
      isDate: true,
    },
    { id: "pricingManagerApproverDetails", label: "Pricing Manager Approver" },
    {
      id: "pricingManagerApprovalDate",
      label: "Pricing Manager Approval Date",
      isDate: true,
    },
    { id: "pricingVPapproverDetails", label: "Pricing VP Approver" },
    {
      id: "pricingVPApprovalDate",
      label: "Pricing VP Approval Date",
      isDate: true,
    },
  ];

  const handleChangeSearch = (text) => {
    setsearchText(text);
    setPageNumber(Content.INITALPAGENO);
  };

  const navigate = useNavigate();

  const closeNotificationPopup = () => {
    setShowNotification(false);
  };

  const CompareQuotesPage = () => {
    let isOppReneval = true;
    if (opportunity?.opportunityType === "New Business") {
      isOppReneval = false;
    }
    console.log(opportunity, "oppurtunityyy");
    console.log(isOppReneval, "isopp");
    navigate("/comparequote", {
      state: {
        opportunityId: selectedOpportunity,
        isOpportunityRenewal: isOppReneval,
      },
    });
  };
  const CreateRequestPage = () => {
    setCreateBtnLoading(true);
    sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, PageName.QUOTEPAGE);
    sessionStorage.setItem(LocalStorageKeys.OPPORTUNITYID, selectedOpportunity);
    setLoadingState(true);
    dispatch(getCRMDataDetails(selectedOpportunity))
      .then((data) => {
        setCreateBtnLoading(false);
        setLoading(false);
        setLoadingState(false);
        navigate("/quoterequest", {
          state: {
            oppurtunityId: selectedOpportunity,
            requestType: "Create",
          },
        });
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
        setLoadingState(false);
      });
  };
  const EditRequest = (quoteId) => {
    sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, PageName.QUOTEPAGE);
    //sessionStorage.setItem(LocalStorageKeys.OPPORTUNITYID, selectedOpportunity);
    navigate("/quoterequest", {
      state: {
        quoteId: quoteId,
        requestType: "Edit",
      },
    });
  };

  const DuplicateRequest = (quoteId) => {
    sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, PageName.QUOTEPAGE);
    navigate("/quoterequest", {
      state: {
        quoteId: quoteId,
        requestType: "Duplicate",
      },
    });
  };

  const filterMyRequests = () => {
    const currValue = isMyRequests;
    if (currValue) {
      setIsMyRequests(false);
    } else {
      setIsMyRequests(true);
    }
  };

  const filterAllQuotes = (data) => {
    console.log("Is My Request", isMyRequests);
    if (isMyRequests) {
      setPreviousQuotes([...data]);
      setQuoteList([
        ...data.filter((x) => x.createdBy === loggedinuser?.user?.id),
      ]);
    } else {
      setQuoteList([...data]);
    }
  };

  const handleStatusFilterClick = (statusId) => {
    console.log("Click Status Filter statusId", statusId);

    const data = [...allQuotes];
    setQuoteList([]);
    setPageNumber(Content.INITALPAGENO);
    switch (statusId) {
      case 0:
        filterAllQuotes(data);
        break; //All
      case QuoteStatus.SAVEASDRAFT:
        filterQuotesByStatus(QuoteStatus.SAVEASDRAFT, data);
        break;
      case QuoteStatus.QUOTEPENDINGPRICINGTEAM:
        filterQuotesByStatus(QuoteStatus.QUOTEPENDINGPRICINGTEAM, data);
        break;
      case QuoteStatus.QUOTEPENDINGSAMLEADERSHIP:
        filterQuotesByStatus(QuoteStatus.QUOTEPENDINGSAMLEADERSHIP, data);
        break;
      case QuoteStatus.QUOTEAPPROVED:
        filterQuotesByStatus(QuoteStatus.QUOTEAPPROVED, data);
        break;
      case QuoteStatus.CONTRACTED:
        filterQuotesByStatus(QuoteStatus.CONTRACTED, data);
        break;
      case QuoteStatus.QUOTECLOSED:
        filterQuotesByStatus(QuoteStatus.QUOTECLOSED, data);
        break;
      case QuoteStatus.QUOTEPENDINGPRICINGMANAGER:
        filterQuotesByStatus(QuoteStatus.QUOTEPENDINGPRICINGMANAGER, data);
        break;
      case QuoteStatus.QUOTEPENDINGPRICINGMANAGERANDSAMLEADERSHIP:
        filterQuotesByStatus(
          QuoteStatus.QUOTEPENDINGPRICINGMANAGERANDSAMLEADERSHIP,
          data,
        );
        break;
      case QuoteStatus.QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP:
        filterQuotesByStatus(
          QuoteStatus.QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP,
          data,
        );
        break;
      case QuoteStatus.QUOTEPENDINGPRICINGVP:
        filterQuotesByStatus(QuoteStatus.QUOTEPENDINGPRICINGVP, data);
        break;
      case QuoteStatus.QUOTEPENDINGINITIALREQUESTOR:
        filterQuotesByStatus(QuoteStatus.QUOTEPENDINGINITIALREQUESTOR, data);
        break;
      default:
        filterAllQuotes(data);
        break;
    }
  };

  return (
    <>
      <AuthenticatedTemplate>
        <HomePageWrapper
          className={loadingState ? "content-pointer-event-none" : ""}
        >
          <Banner
            Heading={Content.BANNER_HEADING}
            Paragraph={Content.BANNER_PARA}
          />
          <StatusBox
            inputInfo={filteredStatus}
            handleStatusClick={handleStatusFilterClick}
          />
          <div className="homeloader">
            {loadingState ||
              (quoteListLoading && (
                <Box className="loader">
                  {/* <CircularProgress size={24} /> */}
                  <Typography variant="subtitle2" gutterBottom>
                    {loadingText}
                  </Typography>
                </Box>
              ))}
          </div>
          <Box className="homePageContainer">
            <Container maxWidth="xl">
              <div className=" tableHeaderRight d-flex">
                <Box
                  sx={{ m: 1, position: "relative", alignItems: "center" }}
                  className="buttonBox"
                >
                  <Typography variant="h4">{Content.QUOTE_REQUEST}</Typography>
                  <div className="myRequestContainer">
                    <FormControlLabel
                      className={
                        isMyRequests ? "btnMyRequest-active" : "btnMyRequest"
                      }
                      control={
                        <Switch
                          checked={isMyRequests}
                          onChange={filterMyRequests}
                          name="myrequests"
                        />
                      }
                      label="My created requests"
                    />
                  </div>
                </Box>

                {selectedOpportunity !== "" && selectedOpportunity !== "0" ? (
                  <Box
                    sx={{ m: 1, position: "relative" }}
                    className="buttonBox"
                  >
                    {quoteList?.length > 0 && (
                      <Button
                        onClick={CompareQuotesPage}
                        color="primary"
                        className="compareButton"
                        variant="contained"
                      >
                        {Content.VISUALIZE}
                      </Button>
                    )}
                    <CustomButton
                      buttonName={
                        createBtnLoading
                          ? "Loading Data.."
                          : Content.CREATE_REQUEST
                      }
                      onClick={CreateRequestPage}
                      disabled={createBtnLoading}
                    ></CustomButton>
                  </Box>
                ) : null}
              </div>
              <Box className="tableSearchHeader">
                <div className="d-flex">
                  <SearchInput
                    placeholder="Search"
                    onSearchChange={handleChangeSearch}
                  />
                  <div className="tableHeaderLeft">
                    {selectedOpportunity != 0 && (
                      <Typography variant="h5">
                        {Content.ACCOUNT_NAME}
                        <span>{opportunity.account}</span>
                      </Typography>
                    )}
                    {selectedOpportunity != 0 && (
                      <Typography variant="h5">
                        {Content.OPP_NAME}
                        <span>{opportunity.opportunityName}</span>
                      </Typography>
                    )}
                    <Typography variant="h5">{Content.OPP_ID}</Typography>
                    {/*<CustomSelect options={opportunityIds} placeholder="Select an Opportunity ID" onSelect={handleSelect1} />*/}

                    <FormControl className="customDropdown">
                      <Autocomplete
                        size="small"
                        options={opportunityList}
                        getOptionLabel={(option) => option.oppurtunity}
                        value={searchSelectedOpportunity}
                        onChange={handleOpportunityChange}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            {...params}
                            variant="outlined"
                          />
                        )}
                      />
                    </FormControl>
                  </div>
                </div>
              </Box>
              <Box className="tableSection">
                <ActionTabTable
                  rows={quoteList}
                  customActions={customActions}
                  headerCells={customHeaderCells}
                  statusColors={statusColors}
                  searchText={searchText}
                  pageNumber={pageNumber}
                  handleChangePage={handleChangePage}
                  quotesLoading={quoteListLoading}
                />
              </Box>
            </Container>
          </Box>
          <Box></Box>
          {showNotification && (
            <Notification
              open={showNotification}
              onClose={closeNotificationPopup}
              message={notificationMessage}
              severity={notificationSeverity}
            />
          )}
          {loadingState && <Loader open={loadingState} />}
        </HomePageWrapper>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Typography variant="h6">Please wait...</Typography>
        <Loader open={true} />
      </UnauthenticatedTemplate>
    </>
  );
};

export default HomePage;
